import type { MarkCore } from '../core/MarkCore';
import { onAfterPageChange } from './pageLifecycle';
import { measureScrollDepthPercent, resetPageMetrics, updateMaxScrollFromCurrentPosition } from './pageMetrics';

const DEFAULT_THRESHOLDS = [25, 50, 75, 100];

export function installPageScrollDepth(client: MarkCore, thresholds: number[] = DEFAULT_THRESHOLDS) {
  if (typeof window === 'undefined') return;

  const emitted = new Set<number>();

  const resetThresholds = () => {
    emitted.clear();
    resetPageMetrics();
  };

  resetThresholds();
  onAfterPageChange(() => {
    resetThresholds();
  });

  window.addEventListener(
    'scroll',
    () => {
      const depth = updateMaxScrollFromCurrentPosition();
      for (const threshold of thresholds) {
        if (depth >= threshold && !emitted.has(threshold)) {
          emitted.add(threshold);
          client.track('scroll_depth', { percent: threshold });
        }
      }
    },
    { passive: true }
  );
}

export { measureScrollDepthPercent };
